import { render, staticRenderFns } from "./expertDetailModal.vue?vue&type=template&id=28667f95&"
import script from "./expertDetailModal.vue?vue&type=script&lang=js&"
export * from "./expertDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports